import { combineReducers } from "redux";
import { SessionReducer } from "../reducers/SessionReducer";
import { AdminReducer } from "../reducers/AdminReducer";
import { CurriculumReducer } from "../reducers/CurriculumReducer";
import { WorkshopReducer } from "../reducers/WorkshopReducer";

export default combineReducers({
    SessionReducer,AdminReducer,CurriculumReducer,WorkshopReducer
});